export default __webpack_public_path__ + "static/media/ellipse_instaprof.e3799ebe.svg";